import loadable from 'loadable-components';

// Export all the component from current directory here in this file.

//Login
export const LoginLayout = loadable(() => import('./Login/LoginLayout'));
export const LoginHeader = loadable(() => import('./Login/LoginHeader'));
export const LoginMain = loadable(() => import('./Login/LoginMain'));
export const LoginSlides = loadable(() => import('./Login/LoginSlides'));
export const LoginForm = loadable(() => import('./Login/LoginForm'));
export const LoginFormControls = loadable(() =>
  import('./Login/LoginFormControls')
);
export const LoginNewPassword = loadable(() =>
  import('./Login/LoginNewPassword')
);
export const LoginForgotPassword = loadable(() =>
  import('./Login/LoginForgotPassword')
);
export const LoginFooter = loadable(() => import('./Login/LoginFooter'));
export const LoginFormContainer = loadable(() =>
  import('./Login/LoginFormContainer')
);

//Home Layout
export const HomeLayout = loadable(() => import('./Home/HomeLayout'));
export const HomeHeader = loadable(() => import('./Home/HomeHeader'));
export const HomeHeaderContainer = loadable(() =>
  import('./Home/HomeHeaderContainer')
);
export const HomeMain = loadable(() => import('./Home/HomeMain'));
export const HomeMainContainer = loadable(() =>
  import('./Home/HomeMainContainer')
);
export const HomeNavigation = loadable(() => import('./Home/HomeNavigation'));
export const HomeNavigationContainer = loadable(() =>
  import('./Home/HomeNavigationContainer')
);

//Kiosk Layout
export const KioskHeader = loadable(() => import('./KioskLayout/KioskHeader'));
export const KioskFooter = loadable(() => import('./KioskLayout/KioskFooter'));
export const KioskIdelScreen = loadable(() =>
  import('./KioskLayout/KioskIdelScreen')
);
export const KioskMainHeader = loadable(() =>
  import('./KioskLayout/KioskMainHeader')
);

// Kiosk
export const KioskLayout = loadable(() => import('./Kiosk/KioskLayout'));
export const KioskContent = loadable(() => import('./Kiosk/KioskContent'));
export const KioskBackgroundSlider = loadable(() =>
  import('./Kiosk/KioskBackgroundSlider')
);
export const KioskSlides = loadable(() => import('./Kiosk/KioskSlides'));

// Kiosk Slides
export const KioskSideSlides = loadable(() =>
  import('./KioskLayout/KioskSideSlides')
);

// KioskPickup
export const KioskPickupLayout = loadable(() =>
  import('./KioskPickup/KioskPickupLayout')
);
export const KioskPickupMain = loadable(() =>
  import('./KioskPickup/KioskPickupMain')
);
export const KioskEnroll = loadable(() => import('./KioskPickup/KioskEnroll'));

export const KioskPickupFormContainer = loadable(() =>
  import('./KioskPickup/KioskPickupFormContainer')
);
export const KioskPickupFormControls = loadable(() =>
  import('./KioskPickup/KioskPickupFormControls')
);

// Kiosk Consult
export const KioskConsultLayout = loadable(() =>
  import('./KioskConsult/KioskConsultLayout')
);
export const KioskConsultMain = loadable(() =>
  import('./KioskConsult/KioskConsultMain')
);
export const KioskConsultFormContainer = loadable(() =>
  import('./KioskConsult/KioskConsultFormContainer')
);
export const KioskConsultForm = loadable(() =>
  import('./KioskConsult/KioskConsultForm')
);
export const KioskConsultFormControls = loadable(() =>
  import('./KioskConsult/KioskConsultFormControls')
);

// Kiosk signature
export const KioskSignatureMain = loadable(() =>
  import('./KioskSignature/KioskSignatureMain')
);
export const KioskSignature = loadable(() =>
  import('./KioskSignature/KioskSignature')
);
export const KioskSignatureContainer = loadable(() =>
  import('./KioskSignature/KioskSignatureContainer')
);

// Kiosk Verify Me
export const KioskVerifyMeLayout = loadable(() =>
  import('./KioskVerifyMe/KioskVerifyMeLayout')
);
export const KioskVerifyMeMain = loadable(() =>
  import('./KioskVerifyMe/KioskVerifyMeMain')
);
export const KioskVerifyMeFormContainer = loadable(() =>
  import('./KioskVerifyMe/KioskVerifyMeFormContainer')
);
export const KioskVerifyMeFormControls = loadable(() =>
  import('./KioskVerifyMe/KioskVerifyMeFormControls')
);

// Kiosk Confirm Rx
export const KioskConfimPickupLayout = loadable(() =>
  import('./KioskConfimPickup/KioskConfimPickupLayout')
);
export const KioskConfimPickupMain = loadable(() =>
  import('./KioskConfimPickup/KioskConfimPickupMain')
);
export const KioskConfimPickupFormContainer = loadable(() =>
  import('./KioskConfimPickup/KioskConfimPickupFormContainer')
);
export const KioskConfimPickupFormControls = loadable(() =>
  import('./KioskConfimPickup/KioskConfimPickupFormControls')
);
export const KioskConfirmPickupDetails = loadable(() =>
  import('./KioskConfimPickup/KioskConfirmPickupDetails')
);
export const KioskConfirmPickupPayment = loadable(() =>
  import('./KioskConfimPickup/KioskConfirmPickupPayment')
);

//Kiosk Feedback
export const KioskFeedbackLayout = loadable(() =>
  import('./KioskFeedback/KioskFeedbackLayout')
);
export const KioskFeedbackMain = loadable(() =>
  import('./KioskFeedback/KioskFeedbackMain')
);

//Kiosk Door
export const KioskDoorLayout = loadable(() =>
  import('./KioskDoor/KioskDoorLayout')
);
export const KioskDoorMain = loadable(() =>
  import('./KioskDoor/KioskDoorMain')
);
export const KioskDoorFormContainer = loadable(() =>
  import('./KioskDoor/KioskDoorFormContainer')
);
export const KioskDoorForm = loadable(() =>
  import('./KioskDoor/KioskDoorForm')
);
export const KioskDoorFormControls = loadable(() =>
  import('./KioskDoor/KioskDoorFormControls')
);

//Kiosk Confirm User
export const KioskCollectIDLayout = loadable(() =>
  import('./KioskCollenctID/KioskCollectIDLayout')
);
export const KioskCollectIDMain = loadable(() =>
  import('./KioskCollenctID/KioskCollectIDMain')
);
export const KioskCollectFormContainer = loadable(() =>
  import('./KioskCollenctID/KioskCollectFormContainer')
);
export const KioskCollectForm = loadable(() =>
  import('./KioskCollenctID/KioskCollectForm')
);
export const KioskCollectFormControls = loadable(() =>
  import('./KioskCollenctID/KioskCollectFormControls')
);

//Kiosk Enroll New User
export const KioskEnrollmentLayout = loadable(() =>
  import('./KioskEnrollment/KioskEnrollmentLayout')
);
export const KioskEnrollmentMain = loadable(() =>
  import('./KioskEnrollment/KioskEnrollmentMain')
);
export const KioskEnrollmentFormContainer = loadable(() =>
  import('./KioskEnrollment/KioskEnrollmentFormContainer')
);
export const KioskEnrollmentForm = loadable(() =>
  import('./KioskEnrollment/KioskEnrollmentForm')
);
export const KioskEnrollmentFormControls = loadable(() =>
  import('./KioskEnrollment/KioskEnrollmentFormControls')
);
export const KioskEnrollConfirmation = loadable(() =>
  import('./KioskEnrollment/KioskEnrollConfirmation')
);

/*====================================================Admin Layout================================================ */
/*Admin Login Layout */
export const AdminLoginLayout = loadable(() =>
  import('./AdminLogin/AdminLoginLayout')
);
export const AdminLoginMain = loadable(() =>
  import('./AdminLogin/AdminLoginMain')
);
export const AdminLoginFormContainer = loadable(() =>
  import('./AdminLogin/AdminLoginFormContainer')
);
export const AdminLoginFormControls = loadable(() =>
  import('./AdminLogin/AdminLoginFormControls')
);
export const AdminLoginForm = loadable(() =>
  import('./AdminLogin/AdminLoginForm')
);
export const AdminLoginNewPassword = loadable(() =>
  import('./AdminLogin/AdminLoginNewPassword')
);
export const AdminLoginForgotPassword = loadable(() =>
  import('./AdminLogin/AdminLoginForgotPassword')
);

/*Admin Layout */
export const AdminFooter = loadable(() => import('./AdminLayout/AdminFooter'));
export const AdminHeader = loadable(() => import('./AdminLayout/AdminHeader'));
export const AdminMainHeader = loadable(() =>
  import('./AdminLayout/AdminMainHeader')
);
export const AdminSideSlides = loadable(() =>
  import('./AdminLayout/AdminSideSlides')
);

/*Admin Panel Layout */
export const AdminPanelLayout = loadable(() =>
  import('./AdminPanel/AdminPanelLayout')
);
export const AdminPanelMain = loadable(() =>
  import('./AdminPanel/AdminPanelMain')
);
export const AdminPanelFormContainer = loadable(() =>
  import('./AdminPanel/AdminPanelFormContainer')
);
export const AdminPanelFormControls = loadable(() =>
  import('./AdminPanel/AdminPanelFormControls')
);

/*Admin Panel Stock */

export const AdminPanelStockLayout = loadable(() =>
  import('./AdminPanelStock/AdminPanelStockLayout')
);
export const AdminPanelStockMain = loadable(() =>
  import('./AdminPanelStock/AdminPanelStockMain')
);
export const AdminPanelStockFormContainer = loadable(() =>
  import('./AdminPanelStock/AdminPanelStockFormContainer')
);
export const AdminPanelStockFormControls = loadable(() =>
  import('./AdminPanelStock/AdminPanelStockFormControls')
);

/*Admin Panel Maintanence */
export const AdminMaintenanceLayout = loadable(() =>
  import('./AdminMaintenance/AdminMaintenanceLayout')
);
export const AdminMaintenanceMain = loadable(() =>
  import('./AdminMaintenance/AdminMaintenanceMain')
);
export const AdminMaintenanceFormContainer = loadable(() =>
  import('./AdminMaintenance/AdminMaintenanceFormContainer')
);
export const AdminMaintenanceFormControls = loadable(() =>
  import('./AdminMaintenance/AdminMaintenanceFormControls')
);

/*Admin Panel Settings */
export const AdminSettingLayout = loadable(() =>
  import('./AdminSetting/AdminSettingLayout')
);
export const AdminSettingMain = loadable(() =>
  import('./AdminSetting/AdminSettingMain')
);
export const AdminSettingFormContainer = loadable(() =>
  import('./AdminSetting/AdminSettingFormContainer')
);
export const AdminSettingFormControls = loadable(() =>
  import('./AdminSetting/AdminSettingFormControls')
);

/*Admin Kiosk Verify Settings*/
export const AdminKioskVerifyLayout = loadable(() =>
  import('./KioskVerify/AdminKioskVerifyLayout')
);
export const AdminKioskVerifyMain = loadable(() =>
  import('./KioskVerify/AdminKioskVerifyMain')
);
export const AdminKioskVerifyFormContainer = loadable(() =>
  import('./KioskVerify/AdminKioskVerifyFormContainer')
);
export const AdminKioskVerifyFormControls = loadable(() =>
  import('./KioskVerify/AdminKioskVerifyFormControls')
);
/*Admin Kiosk Verify Settings*/

/*Admin Remove */

export const AdminRemoveLayout = loadable(() =>
  import('./AdminRemove/AdminRemoveLayout')
);
export const AdminRemoveLayoutMain = loadable(() =>
  import('./AdminRemove/AdminRemoveLayoutMain')
);
export const AdminRemoveFormContainer = loadable(() =>
  import('./AdminRemove/AdminRemoveFormContainer')
);
export const AdminRemoveFormControls = loadable(() =>
  import('./AdminRemove/AdminRemoveFormControls')
);
